import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';

const widget = jQuery.widget('ep.overlayWidget', {
	options: {
		visible: true,
		loading: false,
		closeable: true,
		customClass: undefined,
		maxWidth: undefined,
		minWidth: undefined,
		width: undefined,
		height: undefined,
		maxHeight: undefined,
		responsiveHeightPercent: undefined,
		url: undefined,
		iframe: false,
		// trigger element is used to return focus to the element that opened the overlay
		triggerElement: null,
		_urlHasLoaded: false,

		title: '',
		classes: {
			widget: 'overlay-widget',
			widgetExtraClasses: [],
			overlay: 'overlay-widget__overlay',
			titlebar: 'overlay-widget__titlebar',
			closer: 'overlay-widget__closer',
			header: 'overlay-widget__header',
			content: 'overlay-widget__content',
			loading: 'overlay-widget__loading'
		},
		states: {
			visible: 'overlay-widget--visible',
			loading: 'overlay-widget--loading',
			closeable: 'overlay-widget--closeable',
			bodyFixed: 'is-fixed dialog-open'
		},
		content: $('<div/>'),
		listeners: {
			onClose: function(){}
		}
	},

	_create: function(){
		this._createStructure();
		this._bindListeners();
		this._refresh();
		this._setupFocusTrap();
		this._bindResizeListener();
	},

	_createStructure: function(){
		const element = this.element;
		const options = this.options;
		const classes = options.classes;

		element.addClass(classes.widget);
		classes.widgetExtraClasses.forEach((extraClass) => {
			element.addClass(extraClass);
		});

		const overlayElm = jQuery(`<div
		  class="${classes.overlay}"
		  role="dialog"
		  aria-modal="true"
		  aria-labelledby="overlay-widget-title"
		  aria-describedby="overlay-widget-content"
		  tabindex="0"
		/>`);

		const headerElm = jQuery(`
		  <div class="${classes.header}" id="overlay-widget-header"></div>
		`);
		overlayElm.append(headerElm);

		const titlebarElm = jQuery(`
		  <div class="${classes.titlebar}">
			<h2 id="overlay-widget-title"></h2>
		  </div>
		`);
		headerElm.append(titlebarElm);

		const closerElm = jQuery(`
		  <button class="${classes.closer}" aria-label="${__('overlays.labels.close')}">
			<i class="fa fa-times" aria-hidden="true"></i>
		  </button>
		`);
		headerElm.append(closerElm);

		element.append(overlayElm);


		const contentElm = jQuery(`
		  <div class="${classes.content}" id="overlay-widget-content"></div>
		`);
		overlayElm.append(contentElm);
		contentElm.append(options.content);

		const loadingElm = jQuery(`<div class="${classes.loading}"/>`);
		overlayElm.append(loadingElm);

		this._elmCache = {
			overlay: overlayElm,
			titlebar: titlebarElm,
			closer: closerElm,
			content: contentElm,
			loading: loadingElm
		};
	},

	_getViewportHeightInPx: function(percent) {
		if (typeof percent !== 'number' || percent < 0 || percent > 100) return null;
		return window.innerHeight * (percent / 100);
	},

	_bindResizeListener: function () {
		const component = this;
		jQuery(window).on('resize.overlayWidget', function () {
			component._applyResponsiveHeight();
		});
		this._applyResponsiveHeight();
	},

	_applyResponsiveHeight: function () {
		const percent = this.options.responsiveHeightPercent;
		if (typeof percent === 'number') {
			const heightPx = this._getViewportHeightInPx(percent);
			if (heightPx !== null) {
				this._elmCache.overlay.css('height', heightPx + 'px');
			}
		}
	},

	_setupFocusTrap: function () {
		const modal = this.element;
		const focusableSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
			'textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

		modal.on("keydown.trap", function (e) {
			const focusables = modal.find(focusableSelector).filter(':visible');
			const first = focusables.first()[0];
			const last = focusables.last()[0];

			if (e.key !== "Tab") return;

			const active = document.activeElement;

			if (e.shiftKey) {
				if (active === first) {
					e.preventDefault();
					last.focus();
				}
			} else {
				if (active === last) {
					e.preventDefault();
					first.focus();
				}
			}
		});
	},

	mount: function (options, triggerElement) {
		const overlayWidgetWrapperID = "OVERLAY_WIDGET_WRAPPER";
		let overlayWidget = jQuery('#' + overlayWidgetWrapperID);

		if (overlayWidget.length === 0) {
			overlayWidget = jQuery('<div/>', { id: overlayWidgetWrapperID });
			jQuery('body').append(overlayWidget);
		} else {
			overlayWidget.empty();
		}

		overlayWidget.overlayWidget(options);
		overlayWidget.overlayWidget('open', triggerElement);
	},

	open: function(triggerElement) {
		if (triggerElement && triggerElement.length) {
			this.options.triggerElement = triggerElement;
		}
		this._setOption('visible', true);
		this._elmCache.overlay.focus();
		this._setupFocusTrap();
	},

	close: function(){
		if(this.options.closeable){
			this._setOptions({ visible: false });
			// Return focus to the trigger element if we stored it
			if (this.options.triggerElement) {
				this.options.triggerElement.focus();
			}
			this.options.listeners.onClose();
		}
		this.element.off("keydown.trap");
	},

	refreshFocusTrap: function() {
		this._setupFocusTrap();
	},

	_setOption: function(key, value) {
		if (key === 'content') {
			const contentElm = this._elmCache.content;
			contentElm.empty().append(value);

		} else if (key === 'url') {
			const component = this;
			const contentElm = this._elmCache.content;
			contentElm.empty();

			if (this.options.iframe) {
				const iframe = jQuery('<iframe/>', {
					src: value,
					frameborder: 0,
					css: { display: 'block', width: '100%', height: '100%' }
				});

				iframe.on('load', function() {
					component._initContentResizeObserver();
				})

				contentElm.append(iframe);
			} else {
				component._setOption('loading', true);
				jQuery.ajax({
					type:    "GET",
					url:     value,
					success: function(result) {
						component._setOption('content', result);
						component._setOption('loading', false);
						component._initContentResizeObserver();
					}
				});
			}
		} else {
			this._super(key, value);
		}
	},
	_resizeOverlay: function(){
		const PADDING = 60;
		const $iframe = this._elmCache.content.find('iframe');
		if (!$iframe.length) return;
		const iframe = $iframe[0];
		const cw     = iframe.contentWindow;
		if (!cw || !cw.document) return;

		const doc  = cw.document;
		const body = doc.body || doc.documentElement;
		const html = doc.documentElement;

		const newHeight = Math.max(body.scrollHeight, html.scrollHeight) + PADDING;

		this._setOptions({
			height: newHeight + 'px'
		});
	},
	_setOptions: function() {
		this._superApply( arguments );
		this._refresh();
	},

	_bindListeners: function(){

		this._on(this.element, {
			click: '_closeIfUnderlayClicked'
		});

		this._on(this._elmCache.closer, {
			click: 'close'
		});

		this._on(this._elmCache.overlay, {
			keydown: function(e) {
				if (e.key === 'Escape') {
					e.preventDefault();
					this.close();
				}
			}
		});

	},
	_initContentResizeObserver: function(){
		const contentNode = this._elmCache.content[0];
		this._contentRO = new ResizeObserver(entries => {
			this._resizeOverlay();
		});
		this._contentRO.observe(contentNode);
	},
	_closeIfUnderlayClicked: function(event){
		const target = jQuery(event.target);
		if(target.hasClass(this.options.classes.widget)){
			this.close();
		}
	},

	scrollTo: function(elm, scrollTime, offset){
		if(typeof scrollTime === 'undefined'){ scrollTime = 400; }
		if(typeof offset === 'undefined'){ offset = -50; }

		this._elmCache.overlay.scrollTo(elm, scrollTime, {
			interrupt: true,
			offset: { top: offset }
		});
	},

	_refresh: function(){
		const options = this.options;
		const states = options.states;
		const element = this.element;
		const body = jQuery('body');

		if(this.options.url) {
			jQuery('.overlay-widget__content').addClass('overlay-widget__content--async-content-indentation');
		}

		if(options.loading){
			element.addClass(states.loading);
		} else {
			element.removeClass(states.loading);
		}

		if(typeof options.customClass !== 'undefined'){
			element.addClass(options.customClass);
		}

		if(typeof options.maxWidth !== 'undefined'){
			element.find('.'+options.classes.overlay).eq(0).css('max-width', options.maxWidth);
		}

		if(typeof options.minWidth !== 'undefined'){
			element.find('.'+options.classes.overlay).eq(0).css('min-width', options.minWidth);
		}

		if(typeof options.width !== 'undefined'){
			element.find('.'+options.classes.overlay).eq(0).css('width', options.width);
		}

		if(typeof options.maxHeight !== 'undefined'){
			element.find('.'+options.classes.overlay).eq(0).css('max-height', options.maxHeight);
		}

		if(typeof options.height !== 'undefined'){
			element.find('.'+options.classes.overlay).eq(0).css('height', options.height);
		}

		if (!this._urlHasLoaded && typeof options.url !== 'undefined') {
			this._urlHasLoaded = true;
			this._setOption('url', options.url);
		}

		if(options.visible){
			element.addClass(states.visible);
			body.addClass(states.bodyFixed);
		} else {
			element.removeClass(states.visible);
			body.removeClass(states.bodyFixed);
		}

		if(options.closeable){
			element.addClass(states.closeable);
		} else {
			element.removeClass(states.closeable);
		}

		this._elmCache.titlebar.find('h2').text(options.title);
	},

	_destroy: function () {
		// tear down the observer when the widget is destroyed
		if (this._contentRO) {
			this._contentRO.disconnect();
			this._contentRO = null;
		}
		jQuery(window).off('resize.overlayWidget');
		this._super();
	}
});

const OverlayWidgetClass = jQuery.ep.overlayWidget;

OverlayWidgetClass.mount = function(options, triggerElement) {
	const WRAPPER_ID = 'OVERLAY_WIDGET_WRAPPER';

	const old = jQuery('#' + WRAPPER_ID);
	if (old.length) {
		old.overlayWidget('destroy');
		old.remove();
	}

	const wrapper = jQuery('<div/>', { id: WRAPPER_ID });

	wrapper.overlayWidget(options);

	jQuery('body').append(wrapper);

	if (triggerElement && triggerElement.length) {
		wrapper.overlayWidget('open', triggerElement);
	} else {
		wrapper.overlayWidget('open');
	}

	return wrapper;
};

OverlayWidgetClass.close = function() {
	const WRAPPER_ID = 'OVERLAY_WIDGET_WRAPPER';
	const existing = jQuery('#' + WRAPPER_ID);
	if (existing.length) {
		existing.overlayWidget('close');
	}
};

OverlayWidgetClass.refreshFocusTrap = function() {
	const WRAPPER_ID = 'OVERLAY_WIDGET_WRAPPER';
	const existing = jQuery('#' + WRAPPER_ID);
	if (existing.length) {
		existing.overlayWidget('refreshFocusTrap');
	}
};

export { widget as widget };
export default function(){};
